import React, { useEffect, useState } from 'react';
import { HeroBannerWrapper } from '../layouts/HeroBannerWrapper/HeroBannerWrapper';
import { ReferenceCardSection } from '../layouts/ReferenceCardSection/ReferenceCardSection';
import { InfoSection } from '../layouts/InfoSection/InfoSection';
import { ButtonWithContentWrapper } from '../layouts/ButtonWithContentWrapper/ButtonWithContentWrapper';
import { BackToTop } from '../components/BackToTop/BackToTop';
import { Loader } from '../components/Loader/Loader';
import { ButtonTabs } from '../components/ButtonTabs/ButtonTabs';
import { BrandUtil, useContentfulEntries, useContentfulPreview, wineryDirectStates } from 'dw-us-ui';
import { ProductListing } from '../layouts/ProductListing/ProductListing';
import { BeyondTheLabel } from '../layouts/BeyondTheLabel/BeyondTheLabel';
import { BeyondTheLabelMixed } from '../layouts/BeyondTheLabel/BeyondTheLabelMixed';
import { StandardContentBlockWrapper } from '../layouts/StandardContentBlockWrapper/StandardContentBlockWrapper';
import { Breadcrumb } from '../components/Breadcrumb/Breadcrumb';
import { BlogImageContent } from '../components/BlogImageContent/BlogImageContent';
import { MultipleBlogImageContent } from '../components/MultipleBlogImageContent/MultipleBlogImageContent';
import { Helmet } from 'react-helmet';

const HomePage = () => {
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  const { isPreview, sysId } = useContentfulPreview('hub_page_preview');
  const additionalFilters = {
    'fields.slug': 'home-page',
    'fields.brand': brandTag.toUpperCase(),
    'fields.wd': wineryDirectStates.includes(pageLayer[0].stateCode),
  };
  if (sysId?.length) {
    additionalFilters['sys.id'] = sysId;
  }
  let contentReturn = useContentfulEntries({
    contentType: 'hubPage',
    environment: 'master',
    contenfulProperties: { isProduction: !isPreview },
    additionalFilters,
  });

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    if (contentReturn) {
      setLoading(false);
    }
  }, [contentReturn]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const getComponentName = items => {
    const { fields, sys } = items;
    const type = fields?.module || sys?.contentType?.sys?.id;
    switch (type) {
      case 'image_with_content_block':
        return <InfoSection Header={fields?.title} infoBlocks={fields?.blocks} />;

      case 'card_block':
        return <ReferenceCardSection header={fields?.title} cards={fields?.blocks} />;
      case 'button_with_content':
        return <ButtonWithContentWrapper fields={fields} />;
      case 'product':
        return fields?.type === 'add_to_card' ? (
          <ProductListing fields={fields} />
        ) : fields?.itemCode.startsWith('M') ? (
          <BeyondTheLabelMixed itemCode={fields?.itemCode} brand={contentReturn?.brand} />
        ) : (
          <BeyondTheLabel fields={fields} brand={contentReturn?.brand} />
        );
      case 'standard_content_block':
      case 'textBlockWithMobile':
        return <StandardContentBlockWrapper fields={fields} />;
      case 'hero_banner':
      case 'imageBlock':
        return <HeroBannerWrapper bannerContent={fields?.blocks || fields} opacity={fields?.opacity} />;
      case 'nav_tab':
        return <ButtonTabs navTab={fields?.blocks} />;
      case 'breadcrumb':
        return <Breadcrumb fields={fields} />;
      case 'blog_image_content':
        return <BlogImageContent fields={fields} />;
      case 'multiple_blog_image_content':
        return <MultipleBlogImageContent fields={fields} />;

      default: {
        return null;
      }
    }
  };

  return (
    <div className="vineyard-parent">
      {isLoading && <Loader />}
      {contentReturn && (
        <>
          <Helmet>
            {contentReturn?.seoTitle && <title>{contentReturn?.seoTitle}</title>}
            {contentReturn?.seoKeywords && <meta name="keywords" content={contentReturn?.seoKeywords} />}
            {contentReturn?.seoDescription && <meta name="description" content={contentReturn?.seoDescription} />}
          </Helmet>

          <HeroBannerWrapper
            bannerContent={contentReturn?.banner?.fields?.blocks}
            opacity={contentReturn?.banner?.fields?.opacity}
          />
        </>
      )}
      {contentReturn &&
        contentReturn?.section.length > 0 &&
        contentReturn?.section.map(items => {
          return getComponentName(items);
        })}
      <BackToTop />
    </div>
  );
};

export default HomePage;
